export type SystemString = {
    key: string,
    value: string,
}

/* System */
export const String_System_ErrorDialogTitle: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Oops, there was a small problem.',
        },
        {
            key: 'es-mx',
            value: 'Oops, tenemos un pequeño problema.',
        },
        {
            key: 'fr-ca',
            value: 'Oups, il y a eu un petit problème.',
        },
    ];

export const String_System_GeneralError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'There was a problem proceeding with this transaction.\n\nPlease try again.',
        },
        {
            key: 'es-mx',
            value: 'Se encontro un problema procesando esta transacción.\n\nPor favor vuelve a intentar.',
        },
        {
            key: 'fr-ca',
            value: 'Le serveur est fatigué.\n\nVeuillez réessayer pour le réveiller.',
        },
    ];

export const String_System_ConnectionError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Your phone isn\'t connected to that thing called the internet. Please make sure you\'re on WiFi or have cell service and refresh the page.',
        },
        {
            key: 'es-mx',
            value: 'Su teléfono no está conectado a esa cosa llamada el Internet. Por favor asegurate que tengas WiFi o servicio de celular y refresca la página.',
        },
        {
            key: 'fr-ca',
            value: 'Votre téléphone n\'est pas connecté à ce qu\'on appelle l\'internet. Assurez-vous d\'être sur le WiFi ou d\'avoir un service de téléphonie mobile et actualisez la page.',
        },
    ];

export const String_System_Offline: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'The check payment system is currently offline.\n\nPress \'Retry\' to check if this system is back online.',
        },
        {
            key: 'es-mx',
            value: 'El sistema de pagos no está conecado al Internet. Presiona \'Retry\' para checar si ya tiene Internet.',
        },
        {
            key: 'fr-ca',
            value: 'Le système de paiement par chèque est actuellement hors ligne.\n\n Appuyez sur \'Réessayer\' pour vérifier si le système est de nouveau en ligne.',
        },
    ];

export const String_System_ErrorInvalidPhone: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Invalid Phone Number',
        },
        {
            key: 'es-mx',
            value: 'Número de Teléfono Invalido',
        },
        {
            key: 'fr-ca',
            value: 'Numéro de téléphone invalide',
        },
    ];

export const String_System_ErrorInvalidEmail: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Invalid Email Address',
        },
        {
            key: 'es-mx',
            value: 'Dirección de Email Invalida',
        },
        {
            key: 'fr-ca',
            value: 'Adresse électronique non valide',
        },
    ];

export const String_System_ErrorAddressRequired: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Address is required',
        },
        {
            key: 'es-mx',
            value: 'La dirección es requerida',
        },
        {
            key: 'fr-ca',
            value: 'L\'adresse est obligatoire',
        },
    ];

export const String_System_ErrorCityRequired: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'City is required',
        },
        {
            key: 'es-mx',
            value: 'La ciudad es requerida',
        },
        {
            key: 'fr-ca',
            value: 'La ville est requise',
        },
    ];

export const String_System_ErrorPostalCodeRequired: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Postal Code is required',
        },
        {
            key: 'es-mx',
            value: 'El código postal es requerido',
        },
        {
            key: 'fr-ca',
            value: 'Le code postal est requis',
        },
    ];

export const String_System_Yes: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'YES',
        },
        {
            key: 'es-mx',
            value: 'SI',
        },
        {
            key: 'fr-ca',
            value: 'OUI',
        },
    ];

export const String_System_No: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'NO',
        },
        {
            key: 'es-mx',
            value: 'NO',
        },
        {
            key: 'fr-ca',
            value: 'NO',
        },
    ];
 
export const String_System_Ok: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'OK',
        },
        {
            key: 'es-mx',
            value: 'OK',
        },
        {
            key: 'fr-ca',
            value: 'OK',
        },
    ];

export const String_System_Cancel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'BACK',
        },
        {
            key: 'es-mx',
            value: 'REGRESAR',
        },
        {
            key: 'fr-ca',
            value: 'RETOUR',
        },
    ];

export const String_System_CancelButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CANCEL',
        },
        {
            key: 'es-mx',
            value: 'CANCELAR',
        },
        {
            key: 'fr-ca',
            value: 'ANNULER',
        },
    ];

export const String_System_Confirm: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CONFIRM',
        },
        {
            key: 'es-mx',
            value: 'CONFIRMAR',
        },
        {
            key: 'fr-ca',
            value: 'CONFIRMER',
        },
    ];

export const String_System_TryAgain: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TRY AGAIN',
        },
        {
            key: 'es-mx',
            value: 'VOLVER INTENTAR',
        },
        {
            key: 'fr-ca',
            value: 'RÉESSAYER',
        },
    ];

export const String_System_Done: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'DONE',
        },
        {
            key: 'es-mx',
            value: 'COMPLETAR',
        },
        {
            key: 'fr-ca',
            value: 'FAIT',
        },
    ];

export const String_System_View: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VIEW',
        },
        {
            key: 'es-mx',
            value: 'VER',
        },
        {
            key: 'fr-ca',
            value: 'VIEW',
        },
    ];

export const String_System_Pay: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PAY',
        },
        {
            key: 'es-mx',
            value: 'PAGAR',
        },
        {
            key: 'fr-ca',
            value: 'PAYER',
        },
    ];

export const String_System_Check: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECK',
        },
        {
            key: 'es-mx',
            value: 'CUENTA',
        },
        {
            key: 'fr-ca',
            value: 'FACTURE',
        },
    ];

export const String_System_Checks: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECKS',
        },
        {
            key: 'es-mx',
            value: 'CUENTAS',
        },
        {
            key: 'fr-ca',
            value: 'FACTURES',
        },
    ];

export const String_ShareLink1: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Want to split or transfer this check?',
        },
        {
            key: 'es-mx',
            value: '¿Quieres dividir o transferir la cuenta?',
        },
        {
            key: 'fr-ca',
            value: 'Vous souhaitez diviser ou transférer cette facture?',
        },
    ];

export const String_ShareLink2: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Click #here# to share this link.',
        },
        {
            key: 'es-mx',
            value: 'Hazle clic #here# para compartir este link',
        },
        {
            key: 'fr-ca',
            value: 'Cliquez #ici# pour partager ce lien.',
        },
    ];

export const String_CheckPaid: SystemString[] = 
    [
        {
            key: 'en-us',
            value: "You're all Good! The Check has been Paid in Full.",
        },
        {
            key: 'es-mx',
            value: '¡Todo listo! La Cuenta entera ha sido pagada.',
        },
        {
            key: 'fr-ca',
            value: 'Tout va bien! La facture a été payée en totalité.',
        },
    ];

export const String_CheckNoUnclaimedAmounts: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'The full total amount due for this check has already been claimed by other people at your table. You will be navigated back to the Home Screen.',
        },
        {
            key: 'es-mx',
            value: 'El monto total de esta cuenta ya fue reclamado por otras personas en tu grupo. Te vamos a llevar de regreso a la pantalla de Inicio.',
        },
        {
            key: 'fr-ca',
            value: 'Le montant total dû pour cette facture a déjà été réclamé par d\'autres personnes à votre table. Vous retournerez à l\'écran d\'accueil.',
        },
    ];

/* Check Out Component */
export const String_CheckOut_Instruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'READY TO CHECK OUT?',
        },
        {
            key: 'es-mx',
            value: '¿LISTO PARA CERRAR LA CUENTA?',
        },
        {
            key: 'fr-ca',
            value: 'PRÊT À PASSER À LA CAISSE?',
        },
    ];

export const String_CheckOut_Instruction_With_Feedback: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'THANK YOU FOR VISITING!',
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

export const String_CheckOut_Instruction_Sub: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PLEASE COMPLETE PAYMENT BEFORE GETTING UP FROM THE TABLE. THANK YOU! ' + String.fromCodePoint(0x263A),
        },
        {
            key: 'es-mx',
            value: 'POR FAVOR COMPLETA EL PAGO DE TU CUENTA ANTES DE PARARTE DE LA MESA. ¡GRACIAS!' + String.fromCodePoint(0x263A),
        },
        {
            key: 'fr-ca',
            value: 'VEUILLEZ EFFECTUER LE PAIEMENT AVANT DE VOUS LEVER DE VOTRE TABLE. MERCI!' + String.fromCodePoint(0x263A),
        },
    ];

export const String_CheckOut_Instruction_Sub_With_Feedback: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'SELECT FROM THE OPTIONS BELOW TO PAY FOR YOUR CHECK OR LEAVE YOUR VALUABLE FEEDBACK ' + String.fromCodePoint(0x263A),
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];


export const String_CheckOut_AddressLabel: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'ADDRESS:',
    },
    {
        key: 'es-mx',
        value: 'DIRECCIÓN:',
    },
    {
        key: 'fr-ca',
        value: 'ADRESSE:',
    },
];

export const String_CheckOut_CityLabel: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'CITY:',
    },
    {
        key: 'es-mx',
        value: 'CIUDAD:',
    },
    {
        key: 'fr-ca',
        value: 'VILLE:',
    },
];

export const String_CheckOut_PostalCodeLabel: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'POSTAL CODE:',
    },
    {
        key: 'es-mx',
        value: 'CÓDIGO POSTAL:',
    },
    {
        key: 'fr-ca',
        value: 'CODE POSTAL:',
    },
];

export const String_CheckOut_PhoneLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PHONE:',
        },
        {
            key: 'es-mx',
            value: 'TELEFONO:',
        },
        {
            key: 'fr-ca',
            value: 'TÉLÉPHONE:',
        },
    ];


export const String_CheckOut_EmailLabel: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'EMAIL:',
    },
    {
        key: 'es-mx',
        value: 'CORREO:',
    },
    {
        key: 'fr-ca',
        value: 'COURRIEL:',
    },
];

export const String_CheckOut_TableLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TABLE:',
        },
        {
            key: 'es-mx',
            value: 'MESA:',
        },
        {
            key: 'fr-ca',
            value: 'TABLE:',
        },
    ];

export const String_CheckOut_NoOpenChecks_TextToPay: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Your server has not opened a check for this table yet. When you are ready to pay, tap the link that was texted to you.\n\nEnjoy your meal!',
        },
        {
            key: 'es-mx',
            value: '¡OYE ESPERA! AUNQUE APRECIAMOS TU ENTUSIASMO POR CERRAR LA CUENTA USANDO NUESTRO APP, AL PARECER TODAVÍA NO ABRES UNA CUENTA.\n\nDESPUÉS DE QUE EL PERSONAL DEL LUGAR HAYA TOMADO TU ORDEN Y TERMINES DE COMER, SIMPLEMENTE REFRESCA O REGRESA A ESTA PÁGINA PARA CERRAR LA CUENTA. ¡DISFRUTA TU COMIDA!',
        },
        {
            key: 'fr-ca',
            value: 'Votre serveur n\'a pas encore ouvert la facture pour cette table. Lorsque vous serez prêt à payer, appuyez sur le lien qui vous a été envoyé par SMS.\n\n Bon appétit!',
        },
    ];

export const String_CheckOut_NoOpenChecks_ScanToPay: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Your server has not opened a check for this table yet. When you are ready to pay, scan the QR code on your table.\n\nEnjoy your meal!',
        },
        {
            key: 'es-mx',
            value: 'Tu mesera(o) todavía no abre una cuenta para esta mesa. Cuando estes listo para pagar, escanea el código QR en tu mesa.\n\n¡Disfruta tu comida!',
        },
        {
            key: 'fr-ca',
            value: 'Votre serveur n\'a pas encore ouvert la facture pour cette table. Lorsque vous serez prêt à payer, scannez le code QR de votre table. \n\nBon appétit!',
        },
    ];

export const String_CheckOut_NoOpenChecks_ScanReceiptToPay: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Either the QR you scanned is invalid, or the check is alredy closed. Please ask your server for help.',
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

export const String_CheckOut_ViewMenuButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VIEW MENU',
        },
        {
            key: 'es-mx',
            value: 'VER MENÚ',
        },
        {
            key: 'fr-ca',
            value: 'VOIR LE MENU',
        },
    ];

export const String_CheckOut_FeedbackButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'FEEDBACK',
        },
        {
            key: 'es-mx',
            value: 'NEEDS STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEEDS STRING',
        },
    ];


export const String_CheckOut_CheckOutButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECK OUT',
        },
        {
            key: 'es-mx',
            value: 'CERRAR',
        },
        {
            key: 'fr-ca',
            value: 'VÉRIFIER',
        },
    ];

export const String_SystemOffline_Retry: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'RETRY',
        },
        {
            key: 'es-mx',
            value: 'RE-INTENTAR',
        },
        {
            key: 'fr-ca',
            value: 'RETOUR',
        },
    ];

/* Multiple Checks Component */
export const String_MultipleChecks_Instruction = (numberOfChecks: number) => {
    return (
    [
        {
            key: 'en-us',
            value: 'We noticed there are ' + numberOfChecks.toString() + ' checks for your table. Please review and pay for your check.',
        },
        {
            key: 'es-mx',
            value: 'Nos dimos cuenta que hay ' + numberOfChecks.toString() + ' cuentas para tu mesa. Por favor revisalas y paga por tu cuenta.',
        },
        {
            key: 'fr-ca',
            value: 'Nous avons remarqué qu\'il y a ' + numberOfChecks.toString() + ' factures pour votre table. Veuillez vérifier et payer votre facture.',
        },
    ]);
}

export const String_MultipleChecks_CheckNumberLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECK NUMBER:',
        },
        {
            key: 'es-mx',
            value: 'NÚMERO DE CUENTA:',
        },
        {
            key: 'fr-ca',
            value: 'NUMÉRO DE LA FACTURE:',
        },
    ];

export const String_MultipleChecks_CheckTotalLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECK TOTAL:',
        },
        {
            key: 'es-mx',
            value: 'TOTAL DE CUENTA:',
        },
        {
            key: 'fr-ca',
            value: 'TOTAL DE LA FACTURE:',
        },
    ];   

/* View Check Dialog Component */
export const String_ViewCheckDialog_Title: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VIEW CHECK',
        },
        {
            key: 'es-mx',
            value: 'VER CUENTA',
        },
        {
            key: 'fr-ca',
            value: 'VOIR LA FACTURE',
        },
    ];

export const String_ViewCheckDialog_CheckNumberLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECK NUMBER:',
        },
        {
            key: 'es-mx',
            value: 'NÚMERO DE CUENTA:',
        },
        {
            key: 'fr-ca',
            value: 'NUMÉRO DE LA FACTURE:',
        },
    ];

export const String_ViewCheckDialog_PayButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PAY CHECK',
        },
        {
            key: 'es-mx',
            value: 'PAGAR CUENTA',
        },
        {
            key: 'fr-ca',
            value: 'PAYER LA FACTURE',
        },
    ];

/* Check Component */
export const String_Check_PayCheckButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PAY BALANCE',
        },
        {
            key: 'es-mx',
            value: 'PAGAR CUENTA',
        },
        {
            key: 'fr-ca',
            value: 'PAYER EN TOTALITÉ',
        },
    ];

export const String_Check_SplitButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'SPLIT CHECK',
        },
        {
            key: 'es-mx',
            value: 'DIVISIÓN CUENTA',
        },
        {
            key: 'fr-ca',
            value: 'FACTURE SÉPARÉE',
        },
    ];

export const String_Check_CheckNumberLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECK #:',
        },
        {
            key: 'es-mx',
            value: 'NÚMERO DE CUENTA:',
        },
        {
            key: 'fr-ca',
            value: 'FACTURE #:',
        },
    ];

export const String_Check_VoidedItem: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VOIDED',
        },
        {
            key: 'es-mx',
            value: 'ANULADO',
        },
        {
            key: 'fr-ca',
            value: 'ANNULÉ',
        },
    ];

export const String_Check_SubTotal: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Sub Total',
        },
        {
            key: 'es-mx',
            value: 'Sub Total',
        },
        {
            key: 'fr-ca',
            value: 'Sous-Total',
        },
    ];

export const String_Check_TaxesAndFees: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Taxes & Fees',
        },
        {
            key: 'es-mx',
            value: 'Impuestos & Honorarios',
        },
        {
            key: 'fr-ca',
            value: 'Taxes & Frais',
        },
    ];

export const String_Check_Total: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Total',
        },
        {
            key: 'es-mx',
            value: 'Total',
        },
        {
            key: 'fr-ca',
            value: 'Total',
        },
    ];

export const String_Check_Tip: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Tip',
        },
        {
            key: 'es-mx',
            value: 'Propina',
        },
        {
            key: 'fr-ca',
            value: 'Tip',
        },
    ];

export const String_Check_TotalPaid: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Total Paid',
        },
        {
            key: 'es-mx',
            value: 'Total Pagado',
        },
        {
            key: 'fr-ca',
            value: 'Total Payé',
        },
    ];

export const String_Check_Discount: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Discount',
        },
        {
            key: 'es-mx',
            value: 'Descuento',
        },
        {
            key: 'fr-ca',
            value: 'Rabais',
        },
    ];

export const String_Check_ServiceCharge: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Service Charge',
        },
        {
            key: 'es-mx',
            value: 'Cargo por servicio',
        },
        {
            key: 'fr-ca',
            value: 'Frais de service',
        },
    ];

export const String_Check_ServiceChargePopup = (restaurantName: string, serviceCharge: string) => {
        return (
        [
            {
                key: 'en-us',
                value: 'Large parties at this restaurant require a gratuity of ' + serviceCharge + '%. Please select a tip of ' + serviceCharge + '% or greater to continue.',
            },
            {
                key: 'es-mx',
                value: restaurantName + ' require una propina de ' + serviceCharge + ' que se aplicará automáticamente a tu cuenta',
            },
            {
                key: 'fr-ca',
                value: restaurantName + ' demande un pourboire de  ' + serviceCharge + ' qui sera automatiquement appliqué à votre facture.',
            },
        ]);
    }

    
export const String_Check_CheckPaid: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'CHECK ALREADY PAID',
    },
    {
        key: 'es-mx',
        value: 'LA CUENTA YA SE PAGO',
    },
    {
        key: 'fr-ca',
        value: 'FACTURE DÉJÀ PAYÉE',
    },
];

export const String_Check_CheckDetails: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'Check Details',
    },
    {
        key: 'es-mx',
        value: 'Detalles de la Cuenta',
    },
    {
        key: 'fr-ca',
        value: 'Détails de la facture',
    },
];

export const String_Check_TaxesAndFeesToolTip = (serviceCharge: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'Taxes & Fees includes all applicable local/state taxes and a Digital Service Fee of ' + serviceCharge,
        },
        {
            key: 'es-mx',
            value: 'Impuestos y Tarifas incluyen todos los impuestos locales/estatales aplicables y una Tarifa de Servicio Digital de ' + serviceCharge,
        },
        {
            key: 'fr-ca',
            value: 'Les taxes et frais comprennent toutes les taxes locales et d\'État applicables ainsi que des frais de service numérique de ' + serviceCharge,
        },
    ]);
}

/* Split/Transfer Component */

export const String_Split_TotalLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'BILL TOTAL:',
        },
        {
            key: 'es-mx',
            value: 'TOTAL DE CUENTA',
        },
        {
            key: 'fr-ca',
            value: 'TOTAL DE LA FACTURE:',
        },
    ];

export const String_Split_Instruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Select A Splitting Method',
        },
        {
            key: 'es-mx',
            value: 'Seleccione como Dividir la Cuenta',
        },
        {
            key: 'fr-ca',
            value: 'Sélectionnez une méthode de partage',
        },
    ];

export const String_Split_SplitEvenlyInstruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: "How many people are splitting the bill?",
        },
        {
            key: 'es-mx',
            value: '¿Cuantas personas van a dividir la cuenta?',
        },
        {
            key: 'fr-ca',
            value: 'Combien de personnes partagent la facture?',
        },
    ];  

export const String_Split_SplitBySeatInstruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: "Please select the check you would like to pay",
        },
        {
            key: 'es-mx',
            value: 'Por favor selecciona la cuenta que quieres pagar.',
        },
        {
            key: 'fr-ca',
            value: 'Veuillez sélectionner le facture que vous souhaitez payer.',
        },
    ]; 

export const String_Split_SplitByAmountLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Pay $ Amount',
        },
        {
            key: 'es-mx',
            value: 'Paga la Cantidad de $',
        },
        {
            key: 'fr-ca',
            value: 'Payer le montant en $',
        },
    ];

export const String_Split_SplitByPercentageLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Pay % Amount',
        },
        {
            key: 'es-mx',
            value: 'Paga el % del Total',
        },
        {
            key: 'fr-ca',
            value: 'Payez le montant en %',
        },
    ];

export const String_Split_SplitEvenlyLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Even Split',
        },
        {
            key: 'es-mx',
            value: 'Divide Parejo',
        },
        {
            key: 'fr-ca',
            value: 'Partage égal',
        },
    ];

export const String_Split_SplitBySeatLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Split By Seat',
        },
        {
            key: 'es-mx',
            value: 'Dividir Por Asiento',
        },
        {
            key: 'fr-ca',
            value: 'Répartir Par Siège',
        },
    ];

export const String_Split_SplitEvenlyError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'When splitting evenly, please enter a number greater than 1.',
        },
        {
            key: 'es-mx',
            value: 'Cuanda vayas a dividir parejamente, por favor ingresa un número mayor que 1.',
        },
        {
            key: 'fr-ca',
            value: 'En cas de partage égal, veuillez saisir un nombre supérieur à 1.',
        },
    ];

export const String_Split_SplitAmountError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'The amount you are paying needs to be less than the remaining balance on the check.',
        },
        {
            key: 'es-mx',
            value: 'La cantidad que estas pagando necesita ser menos que el balance restante de la cuenta.',
        },
        {
            key: 'fr-ca',
            value: 'Le montant que vous payez doit être inférieur au solde restant sur la factur.',
        },
    ];

export const String_Split_SplitPercentageError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'The percentage you are paying needs to be less than the remaining percentage balance on the check.',
        },
        {
            key: 'es-mx',
            value: 'El porcentaje que estas pagando necesita ser menos que el balance restante de la cuenta.',
        },
        {
            key: 'fr-ca',
            value: 'Le pourcentage que vous payez doit être inférieur au pourcentage restant sur la facture.',
        },
    ];


export const String_Split_SplitSeatError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Please select the check for the seat you wish to pay.',
        },
        {
            key: 'es-mx',
            value: 'Por favor selecciona la cuenta para el asiento por el que quieres pagar.',
        },
        {
            key: 'fr-ca',
            value: 'Veuillez sélectionner le facture correspondant à la place que vous souhaitez payer.',
        },
    ];

export const String_Split_SplitEvenlyCountLockToolTip: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Someone else from your party has chosen to split evenly and locked in the guest count, so this cannot be changed',
        },
        {
            key: 'es-mx',
            value: 'Alguien de tu grupo ya decidio dividir la cuenta parejamente, entonces ya no se puede cambiar la cantidad de personas',
        },
        {
            key: 'fr-ca',
            value: 'Quelqu\'un d\'autre de votre groupe a choisi de partager en parts égales et a bloqué le nombre d\'invités, qui ne peut donc pas être modifié.',
        },
    ];

export const String_Split_SplitEvenlyLockToolTip: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Someone else from your party has chosen to split evenly, so you will not be able to split by percentage or amount',
        },
        {
            key: 'es-mx',
            value: 'Alguien de tu grupo ya decidio dividir la cuenta parejamente, entonces ya no se puede dividir por pocentaje o monto',
        },
        {
            key: 'fr-ca',
            value: 'Quelqu\'un d\'autre de votre groupe a choisi de partager en parts égales, de sorte que vous ne pourrez pas partager en pourcentage ou en montant.',
        },
    ];

    
export const String_Split_SplitAmountPercentageLockToolTip: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'Someone else from your party has chosen to either split by amount or by percentage, so you will not be able to split evenly',
    },
    {
        key: 'es-mx',
        value: 'Alguien de tu grupo ya decidio dividir la cuenta por porcentaje o monto, entonces ya no se puede dividir parejamente',
    },
    {
        key: 'fr-ca',
        value: 'Quelqu\'un d\'autre de votre groupe a choisi de partager en montant ou en pourcentage, vous ne pourrez donc pas partager en parts égales.',
    },
];

export const String_Split_SplitByAmountPayLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Pay',
        },
        {
            key: 'es-mx',
            value: 'Pagar',
        },
        {
            key: 'fr-ca',
            value: 'Payer',
        },
    ];

export const String_Split_SplitByAmountOfLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'of',
        },
        {
            key: 'es-mx',
            value: 'de',
        },
        {
            key: 'fr-ca',
            value: 'de',
        },
    ];

export const String_Split_SplitDemoMessage: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Please note that since this a demo, you will be paying out the full check amount',
        },
        {
            key: 'es-mx',
            value: 'Por favor recuerda que esto solo es un demo, entonces vas a pagar la cantidad entera de la cuenta',
        },
        {
            key: 'fr-ca',
            value: 'Veuillez noter que puisqu\'il s\'agit d\'une démo, vous devrez payer le montant total de votre facture.',
        },
    ];

export const String_Split_SplitByAmountClaimSummaryString = (amountUnclaimed: string, total: string) => {
        return (
        [
            {
                key: 'en-us',                
                value: amountUnclaimed + ' of ' + total + ' remaining',
            },
            {
                key: 'es-mx',
                value: 'Le sobra ' + amountUnclaimed + ' al ' + total,
            },
            {
                key: 'fr-ca',
                value: amountUnclaimed + ' reste un montant de ' + total,
            },
        ]);
    }

export const String_Split_SplitByPercentagePayLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Pay',
        },
        {
            key: 'es-mx',
            value: 'Pagar',
        },
        {
            key: 'fr-ca',
            value: 'Payer',
        },
    ];

export const String_Split_SplitByPercentageOfTotalBillLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: '% of total bill',
        },
        {
            key: 'es-mx',
            value: '% total de la cuenta',
        },
        {
            key: 'fr-ca',
            value: '% de la facture totale',
        },
    ];

export const String_Split_SplitByPercentageClaimSummaryString = (percentUnclaimed: string) => {
        return (
        [
            {
                key: 'en-us',                
                value: percentUnclaimed + '% of total bill is unpaid',
            },
            {
                key: 'es-mx',
                value: 'Le sobra ' + percentUnclaimed + '% al total de la cuenta' ,
            },
            {
                key: 'fr-ca',
                value: percentUnclaimed + '% de la facture totale est impayée',
            },
        ]);
    }

/* Pay Check Component */
export const String_PayCheck_ErrorCreditCard: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Oops! There is an error with your credit card information. Please review, update, and then proceed with payment. Thanks!',
        },
        {
            key: 'es-mx',
            value: 'Oops! Hay un error con la información de tu tarjeta de crédito. Por favor revisala, actualiza y luego continua con el pago. ¡Gracias!',
        },
        {
            key: 'fr-ca',
            value: 'Oups! Une erreur s\'est glissée dans les informations relatives à votre carte de crédit. Veuillez les vérifier, les mettre à jour et procéder au paiement. Nous vous remercions de votre attention.',
        },
    ];

export const String_PayCheck_ClaimAmountsChanged: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Someone else has made a claim on the check so the amount left to pay has changed. Please claim a new amount.',
        },
        {
            key: 'es-mx',
            value: 'Alguien mas ha hecho un reclamo en esta cuenta entonces la cantidad restante ha cambiado. Por favor reclama una nueva cantidad.',
        },
        {
            key: 'fr-ca',
            value: 'Quelqu\'un d\'autre a fait une réclamation sur la facture, de sorte que le montant restant à payer a changé. Veuillez demander un nouveau montant.',
        },
    ];

export const String_PayCheck_NextButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'NEXT',
        },
        {
            key: 'es-mx',
            value: 'SIGUIENTE',
        },
        {
            key: 'fr-ca',
            value: 'SUIVANT',
        },
    ];

export const String_PayCheck_BackButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'BACK',
        },
        {
            key: 'es-mx',
            value: 'ATRAS',
        },
        {
            key: 'fr-ca',
            value: 'RETOUR',
        },
    ];

export const String_PayCheck_CompleteButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'COMPLETE',
        },
        {
            key: 'es-mx',
            value: 'COMPLETAR',
        },
        {
            key: 'fr-ca',
            value: 'COMPLET',
        },
    ];

export const String_PayCheck_TotalWithTipLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TOTAL WITH TIP',
        },
        {
            key: 'es-mx',
            value: 'TOTAL CON PROPINA',
        },
        {
            key: 'fr-ca',
            value: 'TOTAL AVEC TIP',
        },
    ];

export const String_PayCheck_Step1Label: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TIP',
        },
        {
            key: 'es-mx',
            value: 'PROPINA',
        },
        {
            key: 'fr-ca',
            value: 'TIP',
        },
    ];

export const String_PayCheck_Step2Label: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'COMPLETE',
        },
        {
            key: 'es-mx',
            value: 'COMPLETAR',
        },
        {
            key: 'fr-ca',
            value: 'COMPLET',
        },
    ];

export const String_PayCheck_PaymentMethodInstruction: SystemString[] =
    [
        {
            key: 'en-us',
            value: 'Please select your payment method',
        },
        {
            key: 'es-mx',
            value: 'Por favor selecciona tu método de pago',
        },
        {
            key: 'fr-ca',
            value: 'Veuillez sélectionner votre mode de paiement',
        },
    ];

export const String_PayCheck_ErrorPaymentFailed: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'There was an issue processing your payment. Check your payment details and try again.',
        },
        {
            key: 'es-mx',
            value: 'Hay un error procesando tu pago. Por favor checa los detalles de pago y vuelve a intentar.',
        },
        {
            key: 'fr-ca',
            value: 'Il y a eu un problème lors du traitement de votre paiement. Vérifiez les détails de votre paiement et réessayez.',
        },
    ];

export const String_PayCheck_ErrorPaymentFailedDeclined: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'This method of payment was declined. Please try again or try another method of payment.',
        },
        {
            key: 'es-mx',
            value: 'Este método de pago fue rechazado. Inténtalo de nuevo o prueba con otro método de pago.',
        },
        {
            key: 'fr-ca',
            value: 'Ce mode de paiement a été refusé. Veuillez réessayer ou essayer un autre mode de paiement.',
        },
    ];

export const String_PayCheck_ErrorPaymentFailedInsufficientFunds: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'This method of payment has insufficient funds. Please try again or try another method of payment.',
        },
        {
            key: 'es-mx',
            value: 'Este método de pago no tiene fondos suficientes. Inténtalo de nuevo o prueba con otro método de pago.',
        },
        {
            key: 'fr-ca',
            value: 'Ce mode de paiement ne dispose pas de fonds suffisants. Veuillez réessayer ou essayer un autre mode de paiement.',
        },
    ];

export const String_PayCheck_ErrorPaymentFailedExpiredCard: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'This method of payment is expired. Please try again or try another method of payment.',
        },
        {
            key: 'es-mx',
            value: 'Este método de pago está caducado. Inténtalo de nuevo o prueba con otro método de pago.',
        },
        {
            key: 'fr-ca',
            value: 'Ce mode de paiement est expiré. Veuillez réessayer ou essayer un autre mode de paiement.',
        },
    ];

export const String_PayCheck_PaymentExceedsAmountDue: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Payment exceeds amount due',
        },
        {
            key: 'es-mx',
            value: 'El pago es mayor a la cantidad que debes',
        },
        {
            key: 'fr-ca',
            value: 'Le paiement dépasse le montant dû',
        },
    ];

export const String_PayCheck_ProcessingPayment: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PROCESSING PAYMENT...',
        },
        {
            key: 'es-mx',
            value: 'PROCESANDO EL PAGO...',
        },
        {
            key: 'fr-ca',
            value: 'TRAITEMENT DU PAIEMENT…',
        },
    ];

export const String_PayCheck_PaymentLongTime: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'ALMOST THERE...',
        },
        {
            key: 'es-mx',
            value: 'YA CASÍ TERMINAMOS...',
        },
        {
            key: 'fr-ca',
            value: 'NOUS Y SOMMES PRESQUE…',
        },
    ];

export const String_PayCheck_CheckClosed: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Looks like someone beat you to it. Your check has been closed.\n\nThank you for dining with us!',
        },
        {
            key: 'es-mx',
            value: 'Parece que alguien se te adelanto. Tu cuenta ya fue cerrada. ¡Gracias pore cenar con nostotros!',
        },
        {
            key: 'fr-ca',
            value: 'On dirait que quelqu\'un vous a devancé. Votre facture a été traitée. Merci d\'avoir mangé avec nous!',
        },
    ];

export const String_PayCheck_ServiceChargePopup = (serviceCharge: string, amount: string) => {
        return (
        [
            {
                key: 'en-us',
                value: 'Please note that a minimum ' + serviceCharge + '% (' + amount + ') is required at this restaurant.',
            },
            {
                key: 'es-mx',
                value: 'Por favor ten en cuenta que un ' + serviceCharge + '% (' + amount + ')  mínimo es requerido en este restaurante.',
            },
            {
                key: 'fr-ca',
                value: 'Veuillez noter qu\'un minimum de  ' + serviceCharge + '% (' + amount + ') est exigé dans ce restaurant.',
            },
        ]);
    }

export const String_PayCheck_PaymentError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Oops! There was an error with your credit card information. Please review, update, and then proceed with payment. Thanks!',
        },
        {
            key: 'es-mx',
            value: 'Oops! Hay un error con la información de tu tarjeta de crédito. Por favor revisala, actualiza y luego continua con el pago. ¡Gracias!',
        },
        {
            key: 'fr-ca',
            value: 'Oups! Une erreur s\'est glissée dans les informations relatives à votre carte de crédit. Veuillez les vérifier, les mettre à jour et procéder au paiement. Merci de votre compréhension.',
        },
    ];

export const String_PayCheck_CreditCardButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Credit Card',
        },
        {
            key: 'es-mx',
            value: 'Tarjeta de crédito',
        },
        {
            key: 'fr-ca',
            value: 'Carte de crédit',
        },
    ];

export const String_PayCheck_RoomChargeButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Charge To Room',
        },
        {
            key: 'es-mx',
            value: 'Cargo a Habitación',
        },
        {
            key: 'fr-ca',
            value: 'Chargement de la chambre',
        },
    ];

export const String_PayCheck_RoomCharge_LastNameLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Last Name:',
        },
        {
            key: 'es-mx',
            value: 'Apellido:',
        },
        {
            key: 'fr-ca',
            value: 'Nom de famille:',
        },
    ];

export const String_PayCheck_RoomCharge_RoomNumberLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Room Number:',
        },
        {
            key: 'es-mx',
            value: 'Número de Habitación:',
        },
        {
            key: 'fr-ca',
            value: 'Numéro de chambre:',
        },
    ];

export const String_PayCheck_RoomCharge_Instruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Please enter your last name and room number.',
        },
        {
            key: 'es-mx',
            value: 'Por favor ingresa tú apellido y número de habitación.',
        },
        {
            key: 'fr-ca',
            value: 'Veuillez saisir votre nom de famille et votre numéro de chambre.',
        },
    ];

export const String_PayCheck_RoomCharge_GuestNotFoundError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Unable to locate guest record. Please check the last name and room number entered.',
        },
        {
            key: 'es-mx',
            value: 'El record del huésped no puede ser localizado. Por favor checa el apellido y número de habitación que ingresaste.',
        },
        {
            key: 'fr-ca',
            value: 'Impossible de localiser le dossier du client. Veuillez vérifier le nom de famille et le numéro de chambre saisis.',
        },
    ];

export const String_PayCheck_RoomCharge_GuestCannotChargeError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'It looks like there is an issue charging to your room. Please contact the server.',
        },
        {
            key: 'es-mx',
            value: 'Al parecer hay un problema haciendo un cargo a tu habitación. Por favor conacta a tu mesera(o).',
        },
        {
            key: 'fr-ca',
            value: 'Un problème de facturation a été détecté pour votre chambre. Veuillez contacter le serveur.',
        },
    ];

export const String_PayCheck_RoomCharge_CompleteButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Charge To Room',
        },
        {
            key: 'es-mx',
            value: 'Cargo a Habitación',
        },
        {
            key: 'fr-ca',
            value: 'Chargement dans la chambre',
        },
    ];

export const String_PayCheck_CardExpirationDateFormatError: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'Card expiration date must be in MM YYYY format.',
    },
    {
        key: 'es-mx',
        value: 'La fecha de expiración de la tarjeta tiene que ser en el formato MM AAAA',
    },
    {
        key: 'fr-ca',
        value: 'La date d\'expiration de la carte doit être au format MM AAAA.',
    },
];

export const String_3DSDialog_Instruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'This restaurant uses 3DS enhanced security for your safety when processing credit card payments. Your address, email, and phone number is never stored, only passed directly to the authorizing bank for the 3DS credit card transaction.',
        },
        {
            key: 'es-mx',
            value: 'Este restaurante utiliza la seguridad mejorada de 3DS para tu seguridad al procesar pagos con tarjeta de crédito. Tu dirección, correo electrónico, y número de teléfono nunca se almanecan, solo se transmiten directamente al banco que autoriza la transacción con la tarjeta de crédito.',
        },
        {
            key: 'fr-ca',
            value: 'Ce restaurant utilise le système de sécurité 3DS pour votre sécurité lors du traitement des paiements par carte de crédit. Votre adresse, votre courriel et votre numéro de téléphone ne sont jamais conservés, mais transmis directement à la banque qui autorise la transaction par carte de crédit 3DS.',
        },
    ];

/* Tip Component */

export const String_Tip_SelectTipInstruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PLEASE SELECT A TIP',
        },
        {
            key: 'es-mx',
            value: 'POR FAVOR SELECCIONA LA PROPINA',
        },
        {
            key: 'fr-ca',
            value: 'VEUILLEZ SÉLECTIONNER UN POURBOIRE',
        },
    ];

export const String_Tip_ManualTipInstruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PLEASE ENTER A TIP',
        },
        {
            key: 'es-mx',
            value: 'POR FAVOR INGRESA LA PROPINA',
        },
        {
            key: 'fr-ca',
            value: 'VEUILLEZ SAISIR UN POURBOIRE',
        },
    ];

export const String_Tip_SelectAdditionalTipInstruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PLEASE SELECT AN ADDITIONAL TIP',
        },
        {
            key: 'es-mx',
            value: 'POR FAVOR SELECCIONA LA PROPINA ADICIONAL',
        },
        {
            key: 'fr-ca',
            value: 'VEUILLEZ SÉLECTIONNER UN POURBOIRE SUPPLÉMENTAIRE',
        },
    ];

export const String_Tip_ManualTipButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CUSTOM',
        },
        {
            key: 'es-mx',
            value: 'PERSONALIZADA',
        },
        {
            key: 'fr-ca',
            value: 'PERSONNALISER',
        },
    ];


/* View Terms Popup Component */
export const String_ViewTermsPopup_Title: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TERMS OF SERVICE',
        },
        {
            key: 'es-mx',
            value: 'TÉRMINOS DE SERVICIO',
        },
        {
            key: 'fr-ca',
            value: 'CONDITIONS D\'UTILISATION',
        },
    ];

export const String_ViewTermsPopup_TermsToggle: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TERMS',
        },
        {
            key: 'es-mx',
            value: 'TÉRMINOS',
        },
        {
            key: 'fr-ca',
            value: 'CONDITIONS',
        },
    ];

export const String_ViewTermsPopup_PrivacyToggle: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PRIVACY',
        },
        {
            key: 'es-mx',
            value: 'PRIVACIDAD',
        },
        {
            key: 'fr-ca',
            value: 'CONFIDENTIALITÉ',
        },
    ];

/* Payment Confirm Component */
export const String_PaymentConfirm_PaymentAgreement: SystemString[] = 
    [
        {
            key: 'en-us',
            value: "By clicking 'Complete' you agree to our ",
        },
        {
            key: 'es-mx',
            value: 'Tu aceptas pagar #total y permitir #name# a cobrar tu metodo de pago seleccionado.',
        },
        {
            key: 'fr-ca',
            value: 'En cliquant sur "Terminer", vous acceptez nos conditions de service.',
        },
    ];

export const String_PaymentConfirm_PaymentAgreementTerms: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TERMS OF SERVICE',
        },
        {
            key: 'es-mx',
            value: 'TÉRMINOS DE SERVICIO',
        },
        {
            key: 'fr-ca',
            value: 'CONDITIONS D\'UTILISATION',
        },
    ];

/* Payment Method Component */
export const String_PaymentMethod_ManualLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'MANUAL',
        },
        {
            key: 'es-mx',
            value: 'MANUAL',
        },
        {
            key: 'fr-ca',
            value: 'MANUEL',
        },
    ];

export const String_PaymentMethod_DigitalLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'APPLE PAY/GOOGLE PAY',
        },
        {
            key: 'es-mx',
            value: 'APPLE PAY/GOOGLE PAY',
        },
        {
            key: 'fr-ca',
            value: 'APPLE PAY/GOOGLE PAY',
        },
    ];

/* Payment Tip Component */
export const String_PaymentTip_SubTotalLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'SUB TOTAL:',
        },
        {
            key: 'es-mx',
            value: 'SUB TOTAL:',
        },
        {
            key: 'fr-ca',
            value: 'SOUS-TOTAL:',
        },
    ];

export const String_PaymentTip_TaxAndServiceChargeLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TAXES & FEES:',
        },
        {
            key: 'es-mx',
            value: 'IMPUESTOS & HONORARIOS:',
        },
        {
            key: 'fr-ca',
            value: 'TAXES & FRAIS:',
        },
    ];

export const String_PaymentTip_TotalLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TOTAL:',
        },
        {
            key: 'es-mx',
            value: 'TOTAL:',
        },
        {
            key: 'fr-ca',
            value: 'TOTAL',
        },
    ];

export const String_PaymentTip_TipLabel: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'TIP',
    },
    {
        key: 'es-mx',
        value: 'PROPINA',
    },
    {
        key: 'fr-ca',
        value: 'CONSEIL:',
    },
];

export const String_CaptchaError: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Error verifying reCaptcha. Please try again.',
        },
        {
            key: 'es-mx',
            value: 'Error validando el reCaptcha. Por favor vuelve a intentar.',
        },
        {
            key: 'fr-ca',
            value: 'Erreur lors de la vérification de reCaptcha. Veuillez réessayer.',
        },
    ];

/* Checkout Complete Component */
export const String_CheckoutComplete_ThankYouMessage: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'YOU DID IT! ' + String.fromCodePoint(0x1F973),
        },
        {
            key: 'es-mx',
            value: '¡LO LOGRASTE! ' + String.fromCodePoint(0x1F973),
        },
        {
            key: 'fr-ca',
            value: 'VOUS AVEZ RÉUSSI! ' + String.fromCodePoint(0x1F973),
        },
    ];

export const String_CheckoutComplete_NoReceipt: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Your payment was successful! ' + String.fromCodePoint(0x1F973) + ' We are unable to fetch your receipt right now. Please ask your server for a physical copy if needed. Thank you!',
        },
        {
            key: 'es-mx',
            value: '!Tu pago fue exitoso! ' + String.fromCodePoint(0x1F973) + ' No podemos recuperar tu recibo en este momento. Solicita a tu mesero(a) una copia física si es necesario. ¡Gracias!',
        },
        {
            key: 'fr-ca',
            value: 'Votre paiement a réussi ! ' + String.fromCodePoint(0x1F973) + ' Nous ne sommes pas en mesure de récupérer votre reçu pour le moment. Veuillez demander à votre serveur une copie physique si nécessaire. Merci!',
        },
    ];

export const String_CheckoutComplete_RatingInstruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'RATE YOUR DINING EXPERIENCE BELOW.',
        },
        {
            key: 'es-mx',
            value: 'POR FAVOR CALIFICA TU EXPERIENCIA A CONTINUACIÓN',
        },
        {
            key: 'fr-ca',
            value: 'ÉVALUEZ VOTRE EXPÉRIENCE GASTRONOMIQUE CI-DESSOUS.',
        },
    ];

/* Rating Component */
export const String_Rating_VeryDissatisfiedLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VERY DISSATISFIED',
        },
        {
            key: 'es-mx',
            value: 'MUY INSATISFECHO',
        },
        {
            key: 'fr-ca',
            value: 'TRÈS INSATISFAIT',
        },
    ];

export const String_Rating_DissatisfiedLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'DISSATISFIED',
        },
        {
            key: 'es-mx',
            value: 'INSATISFECHO',
        },
        {
            key: 'fr-ca',
            value: 'INSATISFAIT',
        },
    ];

export const String_Rating_SatisfiedLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'SATISFIED',
        },
        {
            key: 'es-mx',
            value: 'SATISFECHO',
        },
        {
            key: 'fr-ca',
            value: 'SATISFAIT',
        },
    ];

export const String_Rating_VerySatisfiedLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VERY SATISFIED',
        },
        {
            key: 'es-mx',
            value: 'MUY SATISFECHO',
        },
        {
            key: 'fr-ca',
            value: 'TRÈS SATISFAIT',
        },
    ];

export const String_Rating_LeaveFeedbackTitle: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'HOW WAS YOUR EXPERIENCE?',
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

export const String_Rating_LeaveFeedbackText: SystemString[] = 
    [
        {
            key: 'en-us',
            value: "We're sorry you weren't satisfied. Please tell us how we can make an improvement.",
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

/* Email Receipt Dialog Component */
export const String_EmailReceiptDialog_Title: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'EMAIL RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'EMAIL RECIBO',
        },
        {
            key: 'fr-ca',
            value: 'RÉCEPTION PAR COURRIEL',
        },
    ];

export const String_EmailReceiptDialog_Instruction: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Enter your email below to receive a copy of the receipt.',
        },
        {
            key: 'es-mx',
            value: '¿Quire que te enviemos una copia de tu recibo por email? Escribe tu email a continuacion.',
        },
        {
            key: 'fr-ca',
            value: 'Saisissez votre adresse électronique ci-dessous pour recevoir une copie du reçu.',
        },
    ];

export const String_SendReceiptLink_SuccessMessage: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'A copy of your receipt has been sent to you.',
        },
        {
            key: 'es-mx',
            value: 'Se te envio una copia de tu recibo',
        },
        {
            key: 'fr-ca',
            value: 'Une copie de votre reçu vous a été envoyée.',
        },
    ];

/* Text Receipt Dialog Component */
export const String_TextReceiptDialog_Title: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'TEXT RECEIPT',
    },
    {
        key: 'es-mx',
        value: 'RECIBO POR TEXTO',
    },
    {
        key: 'fr-ca',
        value: 'RECEPTION PAR TEXTE',
    },
];

export const String_TextReceiptDialog_Instruction: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'Enter your phone number below to receive a copy of the receipt. By entering your phone number you agree to receive a text message with a link to your receipt.',
    },
    {
        key: 'es-mx',
        value: 'Ingresa tu número de teléfono para recibir una copia de tu recibo.',
    },
    {
        key: 'fr-ca',
        value: 'Entrez votre numéro de téléphone ci-dessous pour recevoir une copie du reçu.',
    },
];

/* Feedback Dialog Component */
export const String_FeedbackDialog_Title: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'SURVEY',
    },
    {
        key: 'es-mx',
        value: 'NEED STRING',
    },
    {
        key: 'fr-ca',
        value: 'NEED STRING',
    },
];

export const String_FeedbackDialog_Instruction: SystemString[] = 
[
    {
        key: 'en-us',
        value: 'Thank you for dining with us, we hope you come back soon! We\'d love to hear feedback on your experience. Please take a moment to tell us how we did today.',
    },
    {
        key: 'es-mx',
        value: 'NEED STRING',
    },
    {
        key: 'fr-ca',
        value: 'NEED STRING',
    },
];

/* Multiple Receipt Component */
export const String_MultipleReceipt_ReceiptLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'RECEIPT:',
        },
        {
            key: 'es-mx',
            value: 'RECIBO:',
        },
        {
            key: 'fr-ca',
            value: 'REÇU:',
        },
    ];

/* Receipt Component */
export const String_Receipt_ReceiptTitle: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'RECIBO:',
        },
        {
            key: 'fr-ca',
            value: 'REÇU:',
        },
    ];

export const String_Receipt_CheckLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CHECK:',
        },
        {
            key: 'es-mx',
            value: 'CUENTA:',
        },
        {
            key: 'fr-ca',
            value: 'FACTURE:',
        },
    ];

export const String_Receipt_PaidDateTimeLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'PAID:',
        },
        {
            key: 'es-mx',
            value: 'PAGADO:',
        },
        {
            key: 'fr-ca',
            value: 'PAYÉ:',
        },
    ];

export const String_Receipt_CardTypeLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CARD TYPE:',
        },
        {
            key: 'es-mx',
            value: 'TIPO DE TARJETA',
        },
        {
            key: 'fr-ca',
            value: 'TYPE DE CARTE:',
        },
    ];

export const String_Receipt_CardNumberLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'CARD #:',
        },
        {
            key: 'es-mx',
            value: '# DE TARJETA',
        },
        {
            key: 'fr-ca',
            value: 'CARTE #:',
        },
    ];

export const String_Receipt_AuthCodeLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'AUTH:',
        },
        {
            key: 'es-mx',
            value: 'AUTORIZACIÓN',
        },
        {
            key: 'fr-ca',
            value: 'AUTORISATION',
        },
    ];

/* Review Check Component */
export const String_ReviewCheck_StatusLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'STATUS',
        },
        {
            key: 'es-mx',
            value: 'ESTADO',
        },
        {
            key: 'fr-ca',
            value: 'STATUT',
        },
    ];

export const String_ReviewCheck_PercentagePaidLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: '% PAID',
        },
        {
            key: 'es-mx',
            value: '% PAGADO',
        },
        {
            key: 'fr-ca',
            value: '% PAYÉ',
        },
    ];

export const String_ReviewCheck_TaxWithServiceChargeLabel: SystemString[] = 
        [
            {
                key: 'en-us',
                value: 'TAXES & FEES:',
            },
            {
                key: 'es-mx',
                value: 'IMPUESTOS & HONORARIOS:',
            },
            {
                key: 'fr-ca',
                value: 'TAXES & FRAIS:',
            },
        ];

/* Review Unpaid Checks Component */
  
export const String_ReviewOutstandingChecks_ViewReceiptButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'RECIBO',
        },
        {
            key: 'fr-ca',
            value: 'REÇU',
        },
    ];

export const String_ReviewOutstandingChecks_Instructions: SystemString[] = 
    [
        {
            key: 'en-us',
            value: "CLICK THE 'VIEW' BUTTON TO REVIEW ANY REMAINING BALANCES FOR YOUR TABLE.",
        },
        {
            key: 'es-mx',
            value: 'HAZ CLIC EN EL BOTÓN "VER" PARA CONSULTAR LAS VENTAS RESTANTES DE TU MESA.',
        },
        {
            key: 'fr-ca',
            value: 'CLIQUEZ SUR LE BOUTON "VOIR" POUR CONSULTER LES SOLDES RESTANTS POUR VOTRE TABLE.',
        },
    ];

/* View Receipt Dialog Component */
export const String_ViewReceiptDialog_ViewReceiptLabel: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VIEW RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'VER RECIBO',
        },
        {
            key: 'fr-ca',
            value: 'VOIR LE REÇU',
        },
    ];

/* View Receipt Component */

export const String_ViewReceipt_ViewReceiptButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'VIEW RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'VER RECIBO',
        },
        {
            key: 'fr-ca',
            value: 'VOIR LE REÇU',
        },
    ];

export const String_ViewReceipt_NoReceiptButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'NO RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'NO RECIBO',
        },
        {
            key: 'fr-ca',
            value: 'NO LE REÇU',
        },
    ];

export const String_ViewReceipt_EmailReceiptButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'EMAIL RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'EMAIL RECIBO',
        },
        {
            key: 'fr-ca',
            value: 'REÇU PAR COURRIEL',
        },
    ];


export const String_ViewReceipt_SentThankYou: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'THANK YOU',
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

export const String_ViewReceipt_TextReceiptButton: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'TEXT RECEIPT',
        },
        {
            key: 'es-mx',
            value: 'RECIBO POR TEXTO',
        },
        {
            key: 'fr-ca',
            value: 'REÇU PAR TEXTE',
        },
    ];

export const String_ViewReceipt_TextEmailDemoMessage: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Please note that since this a demo, the receipt will not be sent',
        },
        {
            key: 'es-mx',
            value: 'Por favor ten en cuenta que como esto es un demo, no se te va a enviar un recibo',
        },
        {
            key: 'fr-ca',
            value: 'Veuillez noter qu\'étant donné qu\'il s\'agit d\'une démo, le reçu ne sera pas envoyé.',
        },
    ];

export const String_ViewReceipt_DemoThankYou: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Thank You!',
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

export const String_ViewReceipt_DemoInfo: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Like what you saw? Want to see more?',
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

export const String_ViewReceipt_ThankYou: SystemString[] = 
    [
        {
            key: 'en-us',
            value: 'Thank You!\n\nPlease visit us again!',
        },
        {
            key: 'es-mx',
            value: 'NEED STRING',
        },
        {
            key: 'fr-ca',
            value: 'NEED STRING',
        },
    ];

/* SignalR Notifications */

export const String_WebHookNotification_AmountClaimed = (claimAmount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'One of the guests in your party has just claimed ' + claimAmount + '.',
        },
        {
            key: 'es-mx',
            value: 'Alguien de tu grupo acaba de reclamar ' + claimAmount + '.',
        },
        {
            key: 'fr-ca',
            value: 'L\'un des invités de votre groupe vient de réclamer  ' + claimAmount + '.',
        },
    ]);
}

export const String_WebHookNotification_AmountClaimedRefreshCheck = (claimAmount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'One of the guests in your party has just claimed ' + claimAmount + '. The check will be refreshed.',
        },
        {
            key: 'es-mx',
            value: 'Alguien de tu grupo acaba de reclamar ' + claimAmount + '. La cuenta se va a actualizar',
        },
        {
            key: 'fr-ca',
            value: 'L\'un des invités de votre groupe vient de réclamer  ' + claimAmount + '. La facture sera actualisée.',
        },
    ]);
}

export const String_WebHookNotification_ClaimedExpiredSelf = (claimAmount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'The claim you made in the amount of ' + claimAmount + ' has expired. The check will be refreshed.',
        },
        {
            key: 'es-mx',
            value: 'El reclamo que hiciste en el monto de ' + claimAmount + ' ya se expiro. La cuenta va a ser actualizada.',
        },
        {
            key: 'fr-ca',
            value: 'La demande que vous avez faite pour un montant de ' + claimAmount + ' a expiré. La facture sera réactualisée.',
        },
    ]);
}

export const String_WebHookNotification_ClaimedExpiredOthers = (claimAmount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'One of the claims made by one of the guests in your party in the amount of ' + claimAmount + ' has expired.',
        },
        {
            key: 'es-mx',
            value: 'Uno de los reclamos hecho por alguien en tu grupo, para el monto de ' + claimAmount + ' ya se expiro.',
        },
        {
            key: 'fr-ca',
            value: 'L\'une des demandes faites par l\'un des invités de votre groupe pour un montant de ' + claimAmount + ' a expiré.',
        },
    ]);
}

export const String_WebHookNotification_ClaimedExpiredOthersRefreshCheck = (claimAmount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'One of the claims made by one of the guests in your party in the amount of ' + claimAmount + ' has expired. The check will be refreshed.',
        },
        {
            key: 'es-mx',
            value: 'Uno de los reclamos hecho por alguien en tu grupo, para el monto de ' + claimAmount + ' ya se expiro. La cuenta se va a actualizar.',
        },
        {
            key: 'fr-ca',
            value: 'L\'une des demandes faites par l\'un des invités de votre groupe pour un montant de ' + claimAmount + ' a expiré. La facture sera réactualisée.',
        },
    ]);
}

export const String_WebHookNotification_PaymentCompleted = (amount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'One of the guests in your party just made a payment of ' + amount + '.',
        },
        {
            key: 'es-mx',
            value: 'Alguien en tu grupo acaba de hacer un pago de ' + amount + '.',
        },
        {
            key: 'fr-ca',
            value: 'L\'un des invités de votre groupe vient d\'effectuer un paiement de ' + amount + '.',
        },
    ]);
}

export const String_WebHookNotification_PaymentCompletedRefreshCheck = (amount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'One of the guests in your party just made a payment of ' + amount + '. The check will be refreshed.',
        },
        {
            key: 'es-mx',
            value: 'Alguien en tu grupo acaba de hacer un pago de ' + amount + '. La cuenta se va a actualizar.',
        },
        {
            key: 'fr-ca',
            value: 'L\'un des invités de votre groupe vient d\'effectuer un paiement de ' + amount + '. La facture sera réactualisée.',
        },
    ]);
}

export const String_WebHookNotification_PaymentCompletedClaimExceedsAmountDue = (amount: string, checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'One of the guests in your party just made a payment of ' + amount + '. The amount you have claimed now exceeds the amount due. You will be taken back to the View Check screen.',
        },
        {
            key: 'es-mx',
            value: 'Alguien en tu grupo acaba de hacer un pago de ' + amount + '. La cantidad que has reclamado ahora es mayor que la cantidad que se debe. Te vamos a regresar a la pantalla de Ver la Cuenta',
        },
        {
            key: 'fr-ca',
            value: 'L\'un des invités de votre groupe vient d\'effectuer un paiement de ' + amount + '. Le montant que vous avez réclamé dépasse maintenant le montant dû. Vous revenez à l\'écran Afficher la facture.',
        },
    ]);
}

export const String_WebHookNotification_CheckClosed = (checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'Check has been paid in full.',
        },
        {
            key: 'es-mx',
            value: 'El total de la Cuenta ha sido pagado.',
        },
        {
            key: 'fr-ca',
            value: 'Check a été payée en totalité.',
        },
    ]);
}

export const String_WebHookNotification_CheckClosedRefreshCheck = (checkNumber: string) => {
    return (
    [
        {
            key: 'en-us',
            value: 'Check has been paid in full. The check will be refreshed.',
        },
        {
            key: 'es-mx',
            value: 'El total de la Cuenta ha sido pagado. La cuenta se actualizará.',
        },
        {
            key: 'fr-ca',
            value: 'Check a été payée en totalité. La facture est actualisée.',
        },
    ]);
}